import { areCropsEqual } from '../utils';
import { useEditSceneModalStateContext } from './EditSceneModalStateContext';

export default function useIsCropDirty() {
  // directly accessing slots here because we need the non-draft crop
  const {
    state: { draftCrop, selectedSlotIndex, slots },
  } = useEditSceneModalStateContext();

  const slot = slots?.[selectedSlotIndex];
  const crop = slot?.staticCrop;

  return (
    !!slot && !!crop && !!draftCrop && !areCropsEqual(crop, draftCrop, 0.1)
  );
}
